// extracted by mini-css-extract-plugin
export var footerContainer = "footer-module--footerContainer--38kEX";
export var footerLogo = "footer-module--footerLogo--1GuMV";
export var footerDescription = "footer-module--footerDescription--17j55";
export var footerContact = "footer-module--footerContact--2tZKY";
export var footerListContainer = "footer-module--footerListContainer--tEfpu";
export var footerListTitle = "footer-module--footerListTitle--2dcdc";
export var footerList = "footer-module--footerList--1DID_";
export var footerListItem = "footer-module--footerListItem--1rnss";
export var copyright = "footer-module--copyright--1R0IZ";
export var footerContainerMobile = "footer-module--footerContainerMobile--1ICaR";
export var footerListContainerMobileGroup = "footer-module--footerListContainerMobileGroup--2Y1sN";
export var footerListContainerMobile = "footer-module--footerListContainerMobile--3c6fT";
export var footerDescriptionMobile = "footer-module--footerDescriptionMobile--27bz8";
export var footerContactMobile = "footer-module--footerContactMobile--2Cedf";
export var copyrightMobile = "footer-module--copyrightMobile--Ko6PO";